import { render, staticRenderFns } from "./RsaGestioneCameraStoricoViewPage.vue?vue&type=template&id=7b684b5c"
import script from "./RsaGestioneCameraStoricoViewPage.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCameraStoricoViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports